import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import Category from '../pages/HomeRoot/pages/Category/Category';
import Games from '../pages/HomeRoot/pages/Games/Games';
import Interests from '../pages/HomeRoot/pages/Interests/Interests';
import Home from '../pages/HomeRoot/pages/Home/Home';
import Story from '../pages/HomeRoot/pages/Story/Story';
import NotFoundWrapper from '../../NotFoundPage/NotFoundWrapper.tsx';
import Stories from '../pages/HomeRoot/pages/Stories/Stories';
import { IDailyLookBookResponce } from '../services/api/lookBook/lookbook-model-definitions.ts';
import { WithCommonPageData } from '../ContextWrapper/WithInterest/WithCommonPageData.tsx';
import {
  CATEGORY_ROUTE_PATH,
  GAMES_ROUTE_PATH,
  INTEREST_ROUTE_PATH,
  NOT_FOUND_PAGE_ROUTE_PATH,
  ROUTER_ANIMATION_TYPE,
  STORIES_ROUTE_PATH,
} from './constants.ts';
import ScrollToTop from '../pages/HomeRoot/components/ScrollToTop/ScrollToTop.tsx';
import { buildMomentRoute, createPathType, MomentRoute } from '@moment/routes/types.ts';
import { fetchDefinitions } from '@moment/net/classic-fotoscapes/fetch-home.ts';
import { fetchStories } from '@moment/net/classic-fotoscapes/fetch-stories.ts';
import { fetchNotFoundRoute, NOT_FOUND_QUERY_KEY } from '@moment/net/classic-fotoscapes/fetch-not-found-route.ts';
import {
  generateStoryFetchLookbookQuery,
  StoryRouteParams,
  StoryRouteResponse,
} from '@moment/net/classic-fotoscapes/lookbook-story-fetch-query.ts';
import { genFetchInterestQuery } from '@moment/net/classic-fotoscapes/fetch-interests-page-data.ts';
import { fetchGames, GAMES_QUERY_KEY } from '@moment/net/classic-fotoscapes/fetch-games.ts';

export const isRouterAnimation = (animationName: string) => {
  return Object.values(ROUTER_ANIMATION_TYPE).includes(animationName);
};

const CATEGORY_ROUTE_MOMENT: MomentRoute<any, object> = {
    path: createPathType<any>(CATEGORY_ROUTE_PATH),
    title: ':interestTitle Galleries and Stories  | Fotoscapes',
    element: (
        <ErrorBoundary>
            <WithCommonPageData>
                <Category />
            </WithCommonPageData>
        </ErrorBoundary>
    ),
    // prefetchQuery: generateFetchInterestQuery,
    prefetchQuerys: genFetchInterestQuery
};


export const CATEGORY_ROUTE = buildMomentRoute(CATEGORY_ROUTE_MOMENT)

const GAMES_ROUTE_MOMENT: MomentRoute<Record<string,string>, void> = {
  path: createPathType<Record<string, string>>(GAMES_ROUTE_PATH),
  title: 'Playable Games',
  description:
    'Kick back and enjoy some of our favorite playable games. Each one only takes a few minutes to explore. We add games weekly, so check back regularly to improve your high scores and try out new games.',
  element: (
    <ErrorBoundary>
      <WithCommonPageData>
        <Games />
      </WithCommonPageData>
    </ErrorBoundary>
  ),
  prefetchQuery: fetchGames,
  prefetchQueryKey: GAMES_QUERY_KEY
};

export const GAMES_ROUTE = buildMomentRoute(GAMES_ROUTE_MOMENT)


const INTERESTS_ROUTE_MOMENT: MomentRoute<Record<string,string>, void> = {
  path: createPathType<Record<string, string>>(INTEREST_ROUTE_PATH),
  title: 'FotoSCAPES Exclusive Stories',
  description: 'Profundice en nuestros temas más destacados.',
  element: (
    <ErrorBoundary>
      <WithCommonPageData>
        <Interests />
      </WithCommonPageData>
    </ErrorBoundary>
  ),
  prefetchQuery: () => { /* empty because of common page data */ },
};

export const INTERESTS_ROUTE = buildMomentRoute(INTERESTS_ROUTE_MOMENT)

const STORIES_ROUTE_MOMENT: MomentRoute<Record<string,string>, IDailyLookBookResponce> = {
  path: createPathType<Record<string, string>>(STORIES_ROUTE_PATH),
  title: 'FotoSCAPES Exclusive Stories',
  description: 'Profundice en nuestros temas más destacados.',
  element: (
    <WithCommonPageData>
      <Stories />
    </WithCommonPageData>
  ),
  prefetchQuery: fetchStories,
};

export const STORIES_ROUTE = buildMomentRoute(STORIES_ROUTE_MOMENT)



const HOMEPAGE_ROUTE_MOMENT: MomentRoute<Record<string,string>, any> = {
  path: createPathType<Record<string, string>>('/'),
  title: 'Curated Stories and Stunning Photography | Fotoscapes',
  description:
    'Discover curated stories and captivating photography at Fotoscapes. Explore a daily dose of celebrity homes, travel destinations, sneakers, cars, and more. Immerse yourself in a world of inspiration and visual delight.',
  element: (
    <ErrorBoundary>
      <WithCommonPageData>
        <Home />
      </WithCommonPageData>
    </ErrorBoundary>
  ),
  // prefetchQuery: fetchHomeData
  prefetchQuerys: fetchDefinitions
};

export const HOMEPAGE_ROUTE = buildMomentRoute(HOMEPAGE_ROUTE_MOMENT)





const STORY_ROUTE_MOMENT: MomentRoute<StoryRouteParams, StoryRouteResponse> = {
  title: ':lookbookTitle | Fotoscapes',
  path: createPathType<StoryRouteParams>('/stories/:uid/:title?'),
  element: (
    <ErrorBoundary>
      <WithCommonPageData>
        <ScrollToTop>
          <Story queryFn={generateStoryFetchLookbookQuery}/>
        </ScrollToTop>
      </WithCommonPageData>
    </ErrorBoundary>
  ),
  prefetchQuery: generateStoryFetchLookbookQuery,
};

export const STORY_ROUTE = buildMomentRoute(STORY_ROUTE_MOMENT)

const NOT_FOUND_ROUTE_MOMENT: MomentRoute<Record<string,string>, IDailyLookBookResponce> = {
  path: createPathType<Record<string, string>>(NOT_FOUND_PAGE_ROUTE_PATH),
  title: 'Not Found | Curated Stories and Stunning Photography | Fotoscapes',
  description:
    'Discover curated stories and captivating photography at Fotoscapes. Explore a daily dose of celebrity homes, travel destinations, sneakers, cars, and more. Immerse yourself in a world of inspiration and visual delight.',
  element: (
    <ErrorBoundary>
      <NotFoundWrapper />
    </ErrorBoundary>
  ),
  prefetchQuery: fetchNotFoundRoute,
  prefetchQueryKey: NOT_FOUND_QUERY_KEY
};

export const NOT_FOUND_PAGE_ROUTE = buildMomentRoute(NOT_FOUND_ROUTE_MOMENT)

export const rootRoutes = [
  HOMEPAGE_ROUTE,
  INTERESTS_ROUTE,
  CATEGORY_ROUTE,
  GAMES_ROUTE,
  STORIES_ROUTE,
  STORY_ROUTE,
  NOT_FOUND_PAGE_ROUTE,
];
